import { gql } from "@apollo/client";

export const GET_ALL_WORKOUT_CATEGORY = gql`
  query workOutCategories(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $id: Float
    $name: String
    $isActive: Boolean
    $orderBy: String
  ) {
    workOutCategories(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      id: $id
      name: $name
      isActive: $isActive
      orderBy: $orderBy
    ) {
      edges {
        node {
          id
          objectId
          name
          description
          logo
          isActive
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`;

export const WORKOUT_CATEGORY = gql`
  query workOutCategory($objectId: ID) {
    workOutCategory(objectId: $objectId) {
      objectId
      name
      isActive
      description
      logo
    }
  }
`;
